/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from './UserCell.module.less';
import { StatusFilterMapper } from '../../../constants';

const INVITE_MAPPER = {
  INVITE_SENT: 'Pending confirmation',
  INVITE_REJECTED: 'Invite Rejected',
  INVITE_EXPIRED: 'Invite Expired',
};

const UsersCell = (props) => {
  const { first_name, last_name, email, status } = props.row.original;

  const inviteDate = status?.invite_date ? moment(status.invite_date).format('MMMM, D, YYYY') : null;

  if (!status) {
    return null;
  }

  return (
    <div className={styles.container}>
      <strong className={styles.name}>{`${first_name} ${last_name}`}</strong>
      <div className={styles.wrapper}>
        <span className={styles.email}>{email}</span>
        {status.type === StatusFilterMapper.INVITE || status.type === StatusFilterMapper.PENDING ? (
          <>
            {inviteDate ? (
              <div className={[styles.pendingInvite, styles.tooltip].join(' ')}>
                <div className={styles.dot} />
                {INVITE_MAPPER[status.invite_status] || INVITE_MAPPER.INVITE_SENT}
                <span className={[styles.tooltip, styles.tooltiptext].join(' ')}>
                  {gettext(`An invitation was sent in ${inviteDate}`)}
                </span>
              </div>
            ) : (
              <div className={styles.pendingInvite}>
                <div className={styles.dot} />
                {INVITE_MAPPER[status.invite_status] || INVITE_MAPPER.INVITE_SENT}
              </div>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

UsersCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.object,
  }),
};

export default UsersCell;
